<template>
  <div class="root">
    <div class="login h-screen">
      <div class="flex  items-center text-center text-2xl">
        <h3>{{ $root.config.appName }}</h3>
      </div>
      <template>
        <form
          @submit="loginRequest()"
          action="javascript:void(0)"
          class="uk-form-stacked"
        >
          <div class="login-marg">
            <label class="uk-form-label">E-Posta</label>
            <div class="uk-form-controls">
              <input
                class="uk-input"
                v-model="form.email"
                placeholder
                type="text"
              />
            </div>
          </div>
          <div class="login-marg">
            <label class="uk-form-label">Şifre</label>
            <div class="uk-form-controls">
              <input
                class="uk-input"
                v-model="form.password"
                placeholder
                type="password"
              />
            </div>
          </div>
          <div class="login-marg">
            <label class="uk-form-controls">
              <input
                class="uk-checkbox"
                value="1"
                name="remember_me"
                type="checkbox"
              />
              Beni hatırla
            </label>
          </div>
          <button type="submit" class="login-button green-button">
            <div class="flex space-x-2 items-center justify-start">
              <span>Giriş yap</span>
            </div>
          </button>
        </form>
        <div class="text-xs  mt-2 opacity-30  login-marg">
          <p class="mb-4">
            &copy; {{ year }} viqqa.com Tüm Hakları Saklıdır.
          </p>

          Powered by
          <a
            class="text-black font-bold"
            target="_blank"
            href="https://viqqa.com/?utm_source=crm"
            >Viqqa</a
          >
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import EventBus from "../components/Ui/EventBus";
import AuthService from "../services/auth";
export default {
  name: "login",
  data() {
    return {
      loading: false,
      year: new Date().getFullYear(),
      form: [],
      messages: [],
      login: false,
    };
  },
  created() {},
  methods: {
    logout() {
      AuthService.logout();
    },
    loginRequest() {
      this.loading = true;
      this.$parent.$emit("loading", true);
      AuthService.login(this.form)
        .then((resp) => {
          if (resp.data.success === true) {
            this.$parent.$emit("logon", "true");

            EventBus.$emit("bottomMessage", {
              open: true,
              duration: 2000,
              type: "success",
              title: "Giriş",
              body: "Başarılı olarak giriş yaptınız",
            });

            localStorage.setItem("authToken", resp.data.token);

            if (localStorage.authToken) {
              setTimeout(() => {
                window.location.href = "/";
              }, 1000);
              //
            }
          } else {
            EventBus.$emit("bottomMessage", {
              open: true,
              duration: 2000,
              type: "error",
              title: "Hatalı Giriş",
              body: resp.data.msg,
            });
          }
        })
        .catch((resp) => {
          EventBus.$emit("bottomMessage", {
            open: true,
            duration: 2000,
            type: "error",
            title: "Hatalı Giriş",
            body: "Crm erişim sorunu",
          });
        })
        .finally(() => {
          this.loading = false;
          this.$parent.$emit("loading", false);
        });
    },
  },
};
</script>
<style>
.root {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.login {
  width: 350px;
  display: flex;
  flex-direction: column;
  margin-top: 100px;
}

.login-marg {
  margin-bottom: 10px;
}

.login-button {
  margin-top: 10px;
}
</style>
